import axios from 'axios';

const checkProductOrderLimit = () => {
  const limitedOrderQty = document.querySelector('[data-limit-order-quantity]');

  if (limitedOrderQty) {
    const addToCartButton = document.querySelector(
      '.c-product-details__add-btn'
    );
    const productHandle = limitedOrderQty.getAttribute('data-product-handle');
    const orderLimit =
      limitedOrderQty.getAttribute('data-maximum-order-quantity') || '';

    axios.get('/cart.js').then(async (res: any) => {
      let limitedItemIsInCart = false;
      const cartItems = res.data.items;
      if (cartItems.length == 0) {
        addToCartButton?.removeAttribute('disabled-by-order-limit');
      } else {
        cartItems.forEach((item: any) => {
          const itemHandle = item.handle;
          if (itemHandle == productHandle) {
            limitedItemIsInCart = true;
            const itemQty = item.quantity;
            if (itemQty >= orderLimit) {
              addToCartButton?.setAttribute('disabled-by-order-limit', 'true');
            } else {
              addToCartButton?.removeAttribute('disabled-by-order-limit');
            }
          }
        });
      }
      if (!limitedItemIsInCart) {
        addToCartButton?.removeAttribute('disabled-by-order-limit');
      }
    });
  }
};

checkProductOrderLimit();

export default checkProductOrderLimit;
